import "./App.css";
import React, {useState} from 'react'
import Navbar from "./components/Navbar";
import TextForm from "./components/TextForm";
import Alert from "./components/Alert";
// import About from './components/About';
// import {BrowserRouter as Router, Switch, Route} from "react-router-dom"
// use this router version: npm install react-router-dom@5.2.0
function App() {
  const [mode, setMode] = useState('light');  //whether dark mode is enabled or not 
  const [alert, setAlert] = useState("Welcome");
  const showAlert=(message)=>{
    setAlert(message)
    setTimeout(() => {
      setAlert(null);
    }, 2000);
  }

  var homeActive = ()=>{
    return("active")
  }
  var aboutActive = ()=>{
    return("")
  }
  var toggleMode = ()=>{
    if(mode === 'light'){
      setMode('dark');
      document.querySelector(".form-check-label").style.color = "white";
      document.body.style.backgroundColor="#042743";
      document.body.style.color="white";
      showAlert("Dark mode has been enable")
      document.title = "Text Utils - Dark Mode"
    }
    
    else{
      setMode('light')
      document.querySelector(".form-check-label").style.color = "black";
      document.body.style.backgroundColor="white";
      showAlert("Light mode has been enable")
      document.body.style.color="black";
    }
  }
  return (
    <>
    {/* <Router> */}
      <Navbar title="TextUtils" link2="About" mode={mode} toggleMode={toggleMode} homeActive={homeActive} aboutActive={aboutActive}/>
      <Alert alert={alert}/>
      <div className="container my-3">
        {/* <Switch> */}
          <TextForm heading="Try Text Utils - Word Counter, Character Counter, Text Modifier" mode={mode} showAlert={showAlert} />
        {/* <Route exact path="/about"> */}
            {/* <About mode={mode}/> */}
          {/* </Route> */}
          {/* <Route exact path="/"> */}
          {/* </Route> */}
          {/* </Switch> */}
      </div>
      {/* </Router> */}
    </>
  );
}

export default App;
